import React, { useEffect, useState } from "react";
import TrackItem from "./TrackItem";

const Track = ({
  track,
  setSelectOption,
  selectOption,
  stateTracks,
  races,
  status,
  setRefreshInfo,
  refreshInfo,
  setRefreshEntries,
  refreshEntries,
  setUpcomingRaceSelected,
  setOffRaceSelected,
  setResultsList,
  openTracks,
  setReadOnlyResults,
  setSelectAllTickets,
  setSelectedTicketsVoidScore,
}) => {
  const [trackStatus, setTrackStatus] = useState("");

  useEffect(() => {
    if (track.Complete) {
      setTrackStatus(
        <i className="fas fa-check fa-bold" style={{ color: "#28a745" }}></i>,
      );
    } else {
      if (
        (track?.UpcomingRace && track?.UpcomingRace?.RaceNumber !== 0) ||
        track?.UpcomingRace?.RaceStatus !== ""
      ) {
        setTrackStatus(
          track.UpcomingRace?.RaceNumber && (
            <>R{track.UpcomingRace.RaceNumber}</>
          ),
        );
      } else {
        setTrackStatus(<span style={{ color: "transparent" }}>.</span>);
      }
    }
  }, [stateTracks]);

  const selectOptionRefresh = () => {
    setResultsList([]);
    setReadOnlyResults([]);
    setRefreshInfo(!refreshInfo);
    setRefreshEntries(!refreshEntries);
    setSelectOption(
      track.TrackID,
      track.TrackName,
      track?.UpcomingRace?.RaceID || 0,
      track?.UpcomingRace?.RaceNumber || 0,
      track.TrackCode,
      status,
      track?.UpcomingRace?.RaceStatus || "",
    );
    setUpcomingRaceSelected(0);
    setOffRaceSelected(0);
    setSelectAllTickets(false);
    setSelectedTicketsVoidScore([]);
  };

  useEffect(() => {
    if (openTracks && openTracks.length !== 0) {
      const collapseElement = document.getElementById(
        "idCollapse" + parseInt(track.TrackID, 10),
      );
      if (collapseElement) {
        if (openTracks.includes(track.TrackID)) {
          collapseElement.classList.add("show");
        } else {
          collapseElement.classList.remove("show");
        }
      }
    }
  }, [openTracks, track]);

  return (
    <>
      <li className="nav-item pcoded-hasmenu pcoded-collap active pcoded-trigger">
        <a
          className="nav-link mt-0 mb-1"
          data-toggle="collapse"
          href={"#idCollapse" + track.TrackID}
          role="button"
          aria-expanded="false"
          aria-controls={"idCollapse" + track.TrackID}
          onClick={() => selectOptionRefresh()}
        >
          <span className="form-group">
            <label
              className="inline-group"
              style={{
                fontSize: "16px",
                whiteSpace: "normal",
                width: "170px",
                margin: "0px",
              }}
            >
              <span style={{ color: "#1cc8e3", fontWeight: "bold" }}>
                {track.TrackCode}
              </span>{" "}
              {track.TrackName}
            </label>
            <label
              className="inline-group"
              style={{ float: "right", marginRight: "22px" }}
            >
              {trackStatus}
            </label>
          </span>
        </a>
        <div
          key={track.TrackID}
          className={"collapse"}
          id={"idCollapse" + track.TrackID}
        >
          <ul className="pcoded-submenu">
            {races &&
              races.map((race) => (
                <TrackItem
                  key={race.RaceID}
                  race={race}
                  track={track}
                  setSelectOption={setSelectOption}
                  selectOption={selectOption}
                  setRefreshInfo={setRefreshInfo}
                  refreshInfo={refreshInfo}
                  setRefreshEntries={setRefreshEntries}
                  refreshEntries={refreshEntries}
                  setUpcomingRaceSelected={setUpcomingRaceSelected}
                  setOffRaceSelected={setOffRaceSelected}
                  setResultsList={setResultsList}
                  setReadOnlyResults={setReadOnlyResults}
                  setSelectAllTickets={setSelectAllTickets}
                  setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
                />
              ))}
          </ul>
        </div>
      </li>
    </>
  );
};

export default Track;
